import * as yup from 'yup'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import FilterListIcon from '@mui/icons-material/FilterList';
import Calculate from '@mui/icons-material/Calculate';
import { CalculoEndosoMasivo } from '../models/calculoEndosoMasivo';
import InputNumber from '../../../../components/inputs/yup/materialui/inputNumber';
import { FamilyRestroom, Save } from '@mui/icons-material';
import { useEffect } from 'react';
import { PermissionGuard } from '../../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../../utils/enums';

interface IProps {
    onCalculate: () => CalculoEndosoMasivo
    onSubmit: () => void
    onGenerarMasivo: () => void
    isFormReseting: boolean
}

export const FormularioCalculoEndoso = ({ onCalculate, onSubmit, onGenerarMasivo, isFormReseting }: IProps) => {

    const validationSchema: yup.ObjectSchema<CalculoEndosoMasivo> = yup.object().shape({
        totalTasaEmision: yup.number().optional(),
        totalTasaEndoso: yup.number().optional(),
        totalMonto: yup.number().optional()
    })

    const {
        register,
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        control,
    } = useForm<CalculoEndosoMasivo>({ resolver: yupResolver(validationSchema) })

    const calcular = () => {
        const result: CalculoEndosoMasivo = onCalculate();
        setValue("totalMonto", result.totalMonto);
        setValue("totalTasaEndoso", result.totalTasaEndoso);
        setValue("totalTasaEmision", result.totalTasaEmision);
    }

    useEffect(() => {
        if (isFormReseting) {
            reset();
        }
    }, [isFormReseting])

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputNumber
                        label="Total tasa emisión"
                        name="totalTasaEmision"
                        control={control}
                        error={errors.totalTasaEmision}
                        minValue={0}
                        maxValue={9999999999}
                        decimales={2}
                        presicion={14}
                        disabled
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputNumber
                        label="Total tasa endoso"
                        name="totalTasaEndoso"
                        control={control}
                        error={errors.totalTasaEndoso}
                        minValue={0}
                        maxValue={9999999999}
                        decimales={2}
                        presicion={14}
                        disabled
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputNumber
                        label="Total monto"
                        name="totalMonto"
                        control={control}
                        error={errors.totalMonto}
                        prefix='UF'
                        minValue={0}
                        maxValue={9999999999}
                        decimales={4}
                        fixedDecimalScale
                        presicion={14}
                        disabled
                    />
                </Grid2>
            </Grid2>

            <Grid2 container size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "10px" }} spacing={3}>
                <PermissionGuard permissions={[TipoFuncionalidad.Endoso_masivo]}>
                    <MButton variant="contained" color="primary" startIcon={<Calculate />} onClick={calcular}>
                        Recalcular
                    </MButton>
                </PermissionGuard>
                
                <PermissionGuard permissions={[TipoFuncionalidad.Endoso_masivo]}>
                <MButton type="submit" variant="contained" color="primary" startIcon={<Save />}>
                    Grabar
                </MButton>
                </PermissionGuard>

                <PermissionGuard permissions={[TipoFuncionalidad.Endoso_masivo]}>
                <MButton variant="contained" color="primary" startIcon={<FamilyRestroom />} onClick={onGenerarMasivo}>
                    Generación Masiva
                </MButton>
                </PermissionGuard>
            </Grid2>
        </form>
    );
}